/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { HazardousLocationClassification } from './HazardousLocationClassification';
import type { SteamTrapInstallDetail } from './SteamTrapInstallDetail';
import type { SteamTrapOperationType } from './SteamTrapOperationType';

/**
 * The subset of steam trap properties that are updated via the `PUT /steamtraps/:trapId` endpoint.
 */
export type SteamTrapUpdate = {
	/**
	 * The Everactive id for the steam trap. The id value must match the value in the path.
	 */
	id: string;
	/**
	 * Flag indicating whether Unexpected Cold event detection is suppressed for this steam trap. Only writable by users with the `super_admin` privilege.
	 */
	suppressUnexpectedCold?: boolean;
	/**
	 * The reason `suppressUnexpectedCold` is being set to true. Only writable by users with the `super_admin` privilege.
	 */
	suppressionReason?: SteamTrapUpdate.suppressionReason;
	/**
	 * Details about the physical location and environment of the steam trap.
	 */
	siteDetail: {
		/**
		 * Short description of how the steam trap is used.
		 */
		application?: string;
		/**
		 * Detailed description of how the steam trap is used.
		 */
		applicationDetail?: string;
		/**
		 * The facility where the steam trap is located.
		 */
		facility: string;
		hazardousLocationClassification?: HazardousLocationClassification;
		/**
		 * The inlet PSI measurement collected during the site survey.
		 */
		inletPSI?: number;
		installDetail?: SteamTrapInstallDetail;
		/**
		 * The location of the steam trap within the facility.
		 */
		location: string;
		operation?: SteamTrapOperationType;
		/**
		 * The diameter of the steam trap pipe in inches.
		 */
		pipeSize?: number;
		surveyData?: {
			/**
			 * A historical property used to identify the Evergateway the steam trap sensor will report through.
			 * @deprecated
			 */
			controlNodeNumber?: number;
			/**
			 * Typically the Evergateway serial number the steam trap sensor will report through.
			 */
			evergatewayAssociationNumber?: string;
			/**
			 * Notes collected when the site survey was conducted that may help in sensor installation.
			 */
			notes?: string;
		};
		/**
		 * The service tag of the steam trap.
		 */
		svcTag?: string;
	};
	/**
	 * Property details of the trap itself.
	 */
	trapDetail: {
		/**
		 * The manufacturer of the steam trap.
		 */
		manufacturer: string;
		/**
		 * The model of the steam trap.
		 */
		model?: string;
		/**
		 * The orifice diameter of the steam trap in inches.
		 */
		orificeDiameter?: number;
		/**
		 * The type of steam trap
		 */
		type?: string;
	};
};

export namespace SteamTrapUpdate {

	/**
	 * The reason `suppressUnexpectedCold` is being set to true. Only writable by users with the `super_admin` privilege.
	 */
	export enum suppressionReason {
		OUTDOOR_TRAP = 'outdoor_trap',
		SEASONAL_TRAP = 'seasonal_trap',
		CUSTOMER_REQUEST = 'customer_request',
		TESTING = 'testing',
	}


}

